import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useScenarioStore } from '../store/useScenarioStore';

/**
 * Phase 22.4: legacy /scenario/:id redirector. Loads the scenario, inspects
 * its mode, and routes to the correct mode-specific URL.
 *
 * Used by old bookmarks and by the scenarios list before the per-card
 * Open buttons were updated.
 */
export default function ScenarioRedirect() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { loadScenario, currentScenario, currentScenarioId } = useScenarioStore();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!id) {
      navigate('/', { replace: true });
      return;
    }
    if (id === 'new') {
      // Default new-scenario URL is no longer valid — bounce to scenarios list
      // so the user uses the explicit two-button picker.
      navigate('/', { replace: true });
      return;
    }
    const idMatch =
      currentScenarioId !== null && String(currentScenarioId) === String(id);
    if (!idMatch) {
      loadScenario(id).catch((e) => setError((e as Error).message));
    }
  }, [id, currentScenarioId, loadScenario, navigate]);

  useEffect(() => {
    if (
      currentScenarioId !== null &&
      id !== undefined &&
      String(currentScenarioId) === String(id)
    ) {
      const target =
        currentScenario.mode === 'fleet'
          ? `/scenario/fleet/${id}`
          : `/scenario/individual/${id}`;
      navigate(target, { replace: true });
    }
  }, [currentScenarioId, currentScenario.mode, id, navigate]);

  if (error) {
    return (
      <div className="max-w-5xl mx-auto px-6 py-10">
        <p className="text-red-300 text-sm">Could not load scenario: {error}</p>
      </div>
    );
  }
  return (
    <div className="max-w-5xl mx-auto px-6 py-10">
      <p className="text-slate-400 text-sm">Loading scenario…</p>
    </div>
  );
}
